<template>
  <SmallSquare content="附加奖只能通过策略发放" class="m-b-20" />
  <a-button type="primary" @click="createAdditional">
    添加附加奖
  </a-button>
  <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
    <template v-slot:action='{ record }'>
      <a @click="checkDetail(record)" href='javascript:;' class="m-r-10">编辑</a>
      <a @click="del(record)" href='javascript:;'>删除</a>
    </template>
  </a-table>
  <!-- <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current='search.page' :page-size='search.limit' :total='total' @change='pageCurrentChange' @showSizeChange="pageSizeChange" /> -->
  <!-- 添加附加奖 -->
  <a-modal v-model:visible="additionalShow" :width="700" title="附加奖" centered @ok="handleOk">
    <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:4}" :wrapper-col="{span:20}">
      <a-form-item label="奖项名称" name='award_name' :rules="[{ required: true, message: '请输入奖项名称' }]">
        <a-input class="width50" v-model:value="form.award_name" placeholder="如: 一等奖"></a-input>
      </a-form-item>
      <a-form-item label="奖项分类" name='awardType'>
        <a-radio-group v-model:value="form.awardType" @change='form.code = ""'>
          <a-radio :value="1">积分</a-radio>
          <a-radio :value="2">红包</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="积分" name='point' v-if="form.awardType==1">
        <a-input-number class="width50" placeholder="请输入积分数" v-model:value="form.point_num"></a-input-number>
      </a-form-item>
      <a-form-item label="送红包" required v-if="form.awardType==2">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.bonus_content" readonly />
          </a-col>
          <a-col :span="12">
            <a-button type="primary" @click="showRed=true">
              选择
            </a-button>
          </a-col>
        </a-row>
        <div style="border:1px dashed #f04635;line-height:2"
          class="s_flex_ali p-t-5 p-l-5 p-b-5 p-r-10  m-t-10 width80">
          <InfoCircleOutlined class="m-r-10" />
          <div> 为避免红包零钱发放失败,请确保红包零钱余额充足,查看余额或充值,请前往<a href="/businessCenter/account" target="_blank">商户中心</a></div>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
  <a-modal :keyboard="false" title="选择红包" v-model:visible="showRed" centered :width='1200' :footer="null"
    destroyOnClose>
    <selectBouns v-on:select="redSelect" :checkout='false'></selectBouns>
  </a-modal>
</template>
<script>
  import useTableSearch from "@/hooks/useTableSearch";
  import { onMounted, ref } from "@vue/runtime-core";
  import { activityAttach, activityAttachDel, activityAttachDetail, attachUpdate, attachStore } from '@/api/qrcodeActivitys'
  import { Modal } from 'ant-design-vue';
  import { iscode } from '../../../../../../../utils/app';
  const defSearch = { limit: 10, page: 1 };
  let columns = [
    { title: "名称", dataIndex: "award_name", key: "award_name" },
    { title: "奖项分类", dataIndex: "award_type_text", key: "award_type_text" },
    { title: "奖项内容", dataIndex: "award_content", key: "award_content" },
    { title: "操作", key: "action", slots: { customRender: "action" } },
  ];
  export default {
    props: { award_id: Number, activity_id: Number },
    setup(props) {
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
        allNum,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
        allNum,
      };
      onMounted(() => {
        // activity_id  award_id
        console.log(props.award_id)
        if (props.award_id) {
          search.value.award_id = props.award_id
          search.value.activity_id = props.activity_id
          tableHoosks.initData(activityAttach, search.value);
        }
      });
      // 添加附加奖项
      const rules = [];
      const form = ref({ award_name: "", type: 1, awardType: "" });
      const additionalShow = ref(false);
      const showRed = ref(false)
      const createAdditional = () => {
        form.value = { award_name: "", type: 'add', awardType: 1 }
        additionalShow.value = true;
      };
      // 确定
      const handleOk = async () => {
        // 处理数据
        if (form.value.awardType == 1) {
          form.value.is_point = 1
          form.value.is_bonus = 0
        } else {
          form.value.is_point = 0
          form.value.is_bonus = 1
        }
        var result;
        console.log(form.value)
        // 判断修改还是添加
        if (form.value.attach_award_id) {
          // 修改
          result = await attachUpdate({ ...form.value, activity_id: props.activity_id, award_id: props.award_id }).then(res => res.data).catch(error => error)
        } else {
          result = await attachStore({ ...form.value, activity_id: props.activity_id, award_id: props.award_id }).then(res => res.data).catch(error => error)
        }
        if (iscode(result, true)) {
          tableHoosks.initData(activityAttach, search.value);
          additionalShow.value = false;
        }

      }
      const redSelect = (data) => {
        form.value.bonus_id = data.id
        form.value.bonus_content = data.amount + `(${data.bonus_type_text})`
        showRed.value = false
      }
      // 删除
      const del = (data) => {
        Modal.confirm({
          centered: true,
          content: "删除后将无法恢复，您确定要删除吗？",
          onOk: async () => {
            let res = await activityAttachDel(props.activity_id, props.award_id, data.attach_award_id).then((res) => res.data);
            if (iscode(res, true)) {
              search.value.page = 1;
              tableHoosks.initData(activityAttach, search.value);
            }
          },
        });
      }
      const getDetail = (data) => {
        return new Promise((resolve) => {
          activityAttachDetail(props.activity_id, props.award_id, data.attach_award_id).then(res => {
            resolve(res.data.data)
          })
        })
      }
      const checkDetail = async (data) => {
        let detail = await getDetail(data).then(res => res)
        form.value = detail
        if (form.value.is_point) {
          form.value.awardType = 1
        } else {
          form.value.awardType = 2
        }
        additionalShow.value = true;
      }
      return {
        ...tableHoosks,
        columns,
        additionalShow,
        showRed,
        form,
        redSelect,
        createAdditional,
        del,
        checkDetail,
        handleOk
      };
    },
  };
</script>